//Assets andd Miscellaneous
import { XCircleIcon } from '@heroicons/react/24/solid';
import styles from './badge.module.css';

//Component Begin
export default function Badge({
  badgeType,
  text,
  status,
  handleRemove,
}: {
  badgeType?: string;
  text: string;
  status?: string;
  handleRemove?: () => void;
}) {
  return (
    <span
      className={`capitalize flex items-center gap-2 ${
        !badgeType && !styles.fallBack
      } ${badgeType && styles[badgeType]} ${status && styles[status]}`}
    >
      {text}
      {handleRemove && <XCircleIcon className='h-4 w-4 hover:text-tertiaryColor-normal cursor-pointer' onClick={handleRemove} />}
    </span>
  );
}
